import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {UserService} from '../../services/user.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AlertPopComponent} from '../alert-pop/alert-pop.component';
import {FormBuilder, FormGroup, Validators, FormControl, FormArray} from '@angular/forms';

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.css'],
  providers: [UserService]
})
export class ChangeEmailComponent implements OnInit {
  form: FormGroup;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      uri: ['registroenlinea', [Validators.required]],
      email: ['', [Validators.email, Validators.required]],
      emailConfirm: ['', [Validators.email, Validators.required]],
      password: ['', [Validators.required]]
    });
   }

  ngOnInit() {
    /* VALIDATE SESSION */
    if (this.userService.getToken()){
      this.userService.check_session().subscribe(response => {
        if (response.status) {
        } else {
          this.userService.destroy_session();
          this.router.navigate(['/login']);
        }
      }, error => {
        console.log(error);
        this.userService.destroy_session();
        this.router.navigate(['/login']);
      });
    }else{
      this.userService.destroy_session();
      this.router.navigate(['/login']);
    }
   /* VALIDATE SESSION */
  }

  openAlert(title, text, action, color, direccion = null): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action,
        color
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (direccion === null) {
        console.log(result);
      } else {
        this.router.navigate([direccion]);
      }
    });

   }

   onSubmit(form) {
    this.userService.changeEmail(this.form.value).subscribe(response => {
      if (response.status) {
        this.openAlert('En espera de confirmación de correo nuevo', response.message, 'Cerrar', 'primary', '/perfil');
      } else {
        this.openAlert('Atención', response.message, 'Cerrar', 'warn');
      }
    }, error => {
      console.log(error);
      this.openAlert('Atención', 'No se puede procesar su petición en este momento', 'Cerrar', 'warn');
    });
  }

}
